import P from "prop-types";
import * as S from "../styles";
import React, { useEffect } from 'react';

import { useAxios } from "../../../../../hooks/useAxiosMobile";
import { SimpleLineChartCard } from "../../ChartCards/SimpleLineChartCard";
import { useState } from "react";

export function TotalSentimentos({ currentIndex, queryState }) {
  const chartStyle = {
    width: "100%",
    height: "100% ",
  };

  const [dados, setDados] = useState(undefined)


  let uri = `/api/mobile/total_sentimentos/?uf=${queryState}`;
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  useEffect(() => {
    let datas = []
    let dadosSentimento1 = []
    let dadosSentimento2 = []
    let dadosSentimento3 = []
    let dadosSentimento4 = []
    let dadosSentimento5 = []
    let dadosSentimento6 = []
    let dadosSentimento7 = []

    if (response && response.dados.length > 0) {
      for (let index = 0; index < response.dados.length; index++) {
        let data = response.dados[index].data.split('-').reverse().join('/');
        if (datas.length > 0) {
          if (datas.indexOf(data) === -1) {
            datas.push(data);

          } 
        }else {
          datas.push(data);
        }
      }//fim for

      for (let index = 0; index < datas.length; index++) {
        dadosSentimento1.push(0)
        dadosSentimento2.push(0)
        dadosSentimento3.push(0)
        dadosSentimento4.push(0)
        dadosSentimento5.push(0)
        dadosSentimento6.push(0)
        dadosSentimento7.push(0)

      } //fim for

      for (let index = 0; index < response.dados.length; index++) {
        let data = response.dados[index].data.split('-').reverse().join('/');
  
        if (response.dados[index].sentimento === "Apoiado(a)") {
          dadosSentimento1[datas.indexOf(data)] = response.dados[index].quantidade;
        }
        if (response.dados[index].sentimento === "Reconhecido(a)") {
          dadosSentimento2[datas.indexOf(data)] = response.dados[index].quantidade;
        }
        if (response.dados[index].sentimento === "Adoecido(a)") {
          dadosSentimento3[datas.indexOf(data)] = response.dados[index].quantidade;
        }
        if (response.dados[index].sentimento === "Raiva") {
          dadosSentimento4[datas.indexOf(data)] = response.dados[index].quantidade;
        }
        if (response.dados[index].sentimento === "Medo") {
          dadosSentimento5[datas.indexOf(data)] = response.dados[index].quantidade;
        }
        if (response.dados[index].sentimento === "Alegre") {
          dadosSentimento6[datas.indexOf(data)] = response.dados[index].quantidade;
        }
        if (response.dados[index].sentimento === "Triste") {
          dadosSentimento7[datas.indexOf(data)] = response.dados[index].quantidade;
        }

      }//fim for


      setDados({
        datas: datas,
        sentimento1: dadosSentimento1,
        sentimento2: dadosSentimento2,
        sentimento3: dadosSentimento3,
        sentimento4: dadosSentimento4,
        sentimento5: dadosSentimento5,
        sentimento6: dadosSentimento6,
        sentimento7: dadosSentimento7,

      })
    }

    // eslint-disable-next-line
  }, [response])


  if(currentIndex!==1){
    return(<></>)
  }
  return (
    <S.Container>
      <S.Container2>
        
          <SimpleLineChartCard
            title="Proporção dos sentimentos ao longo do tempo"
            dados={response && response.dados.length > 0 ? dados : response}
            style={chartStyle}
            error={error}
            loading={loading}
          />
      
      </S.Container2>
    </S.Container>
  );
}

TotalSentimentos.propTypes = {
  currentIndex: P.number.isRequired,
};
